// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ObservabilitySignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ObservabilitySignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M10.471 16.53q-.107-.122-.21-.245a.11.11 0 0 0-.1-.039 6.14 6.14 0 0 1-3.452-.41 6.3 6.3 0 0 1-1.98-1.352 6.34 6.34 0 0 1-1.824-4.462 6.36 6.36 0 0 1 1.824-4.467 6.2 6.2 0 0 1 1.98-1.352 6.1 6.1 0 0 1 2.424-.497c.843 0 .672.029 1 .082a.1.1 0 0 0 .096-.039 8 8 0 0 1 .21-.25c.118-.14.247-.281.375-.421.034-.034.015-.092-.028-.101a7.2 7.2 0 0 0-1.653-.194C5.19 2.783 2 6.023 2 10.017s3.171 7.219 7.11 7.233a7 7 0 0 0 1.71-.203c.047-.01.061-.067.028-.1a16 16 0 0 1-.381-.416z" />
      <path d="M17.995 9.993c.01 4.003-2.676 6.76-4.519 7.967a.24.24 0 0 1-.262 0 11 11 0 0 1-1.49-1.197 11 11 0 0 1-.695-.73 10 10 0 0 1-1.134-1.593c2.072-.381 3.643-2.221 3.643-4.433s-1.576-4.056-3.652-4.433A9.7 9.7 0 0 1 11.005 4a10.6 10.6 0 0 1 2.214-1.96.24.24 0 0 1 .262 0C15.324 3.247 18.005 6 18 9.998z" />
      <path d="M9.895 14.43a4.4 4.4 0 0 1-.804.072H9.07c-2.447-.01-4.423-2.02-4.423-4.5s1.971-4.486 4.414-4.5H9.09a4.3 4.3 0 0 1 .79.072 9 9 0 0 0-.362.7 8.6 8.6 0 0 0-.824 3.714A8.7 8.7 0 0 0 9.53 13.73a8 8 0 0 0 .366.7" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ObservabilitySignetIcon = /* @__PURE__ */ Object.assign(
  ObservabilitySignetIconComponent,
  { displayName: 'ObservabilitySignetIcon' },
);
